import SecondStepLogo from './SecondStepLogo.jsx'
export default SecondStepLogo
